'use client';
// import {
//   basePath,
//   getApiHost,
//   getHost,
//   isProduction,
//   isTestnet
// } from '@gtd/base-utils';
import Head from 'next/head';

import { LayoutContainerProps } from './container';
// import { getJsBridgeCdn, getUniFrameCdn } from '../cdn';
// import { getMetasAndLinks } from '../seo-meta';

interface Props extends LayoutContainerProps {
  locales: string[];
}

export const getUniFrameCdn = (baseEnv: string) => {
  // todo 环境还要细化
  return `${
    process.env.NODE_ENV === 'production'
      ? '/uniframe/uniframe.js'
      : `//www.${baseEnv}.bybit.com/uniframe/uniframe.js`
  }`;
};

export function Header(props: Props) {
  const {
    hasLoadUniFrame,
    env: { BASE_ENV },
    // hasLoadJsBridge,
  } = props;

  return (
    <Head key="test">
      {hasLoadUniFrame && (
        <link rel="preload" href={getUniFrameCdn(BASE_ENV)} as="script" />
      )}

      {/* {hasLoadJsBridge && (
        <link rel="preload" href={getJsBridgeCdn()} as="script" />
      )} */}
    </Head>
  );
}
